export const castMaturity = (maturity: string | (string | null)[] | null | undefined) => {
  if (!maturity || Array.isArray(maturity) || !(maturity === 'lessThanFiveYears' || maturity === 'perpetual')) {
    return undefined;
  }
  return maturity;
};
